export default function resetAnimation (elementId) {
	var element = document.getElementById(elementId);
	if (element) {
		element.style.animation = 'none';
		// eslint-disable-next-line no-unused-vars
		const reflow = element.offsetWidth; /* trigger reflow by accessing offsetWidth */
		element.style.animation = null;
	}
}